module.exports = __webpack_public_path__ + "static/media/support.311c1c0f.png";